'use client';

import { MenuItem } from '@headlessui/react';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import { useEffect, useState, useTransition } from 'react';

import { useToast } from '@/features/toast';
import { Button } from '@/shared';
import { Dialog, DialogFooter } from '@/shared/ui/dialog';

import { resetCourseProgressAction } from '../action/reset-course-progress';

export const ResetProgressMenuItem = () => {
	const pathname = usePathname();
	const { addToast } = useToast();
	const [isOpen, setIsOpen] = useState(false);
	const [shouldOpen, setShouldOpen] = useState(false);
	const [isPending, startTransition] = useTransition();

	useEffect(() => {
		if (shouldOpen) {
			const timer = setTimeout(() => {
				setIsOpen(true);
				setShouldOpen(false);
			}, 100);
			return () => clearTimeout(timer);
		}
	}, [shouldOpen]);

	const courseIdMatch = pathname?.match(/^\/course\/([^/]+)$/);
	const courseId = courseIdMatch?.[1];

	if (!courseId) {
		return null;
	}

	const handleReset = () => {
		startTransition(async () => {
			const result = await resetCourseProgressAction(courseId);

			if (result.success) {
				addToast(
					'Успешно',
					result?.message || 'Прогресс успешно сброшен',
					'success',
				);
				setIsOpen(false);
			} else {
				addToast(
					'Ошибка',
					result?.error || 'Произошла ошибка при сбросе прогресса',
					'error',
				);
			}
		});
	};

	return (
		<>
			<MenuItem>
				{({ focus }) => (
					<button
						type="button"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							setShouldOpen(true);
						}}
						className={clsx(
							{
								'bg-gray-100 outline-none': focus,
							},
							'flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red hover:bg-red-light hover:outline-none',
						)}
					>
						Сбросить прогресс
					</button>
				)}
			</MenuItem>

			<Dialog
				open={isOpen}
				onClose={setIsOpen}
				title="Сброс прогресса курса"
				footer={
					<DialogFooter className="justify-end gap-3">
						<Button
							variant="outline"
							onClick={() => setIsOpen(false)}
							disabled={isPending}
						>
							Отмена
						</Button>
						<Button
							variant="red"
							onClick={handleReset}
							loading={isPending}
							disabled={isPending}
						>
							Да, сбросить прогресс
						</Button>
					</DialogFooter>
				}
			>
				<div className="space-y-4 p-6">
					<p className="text-gray-900">
						Вы уверены, что хотите сбросить весь прогресс по текущему курсу?
					</p>
					<p className="text-sm text-gray-600">
						Это действие необратимо. Будет удален прогресс по всем задачам и
						теоретическим материалам курса.
					</p>
				</div>
			</Dialog>
		</>
	);
};
